import React from 'react';

// helpers
import {getDetailedFields, getSummaryFields} from './helpers';
import {useTranslation} from 'react-i18next';

// components
import {ProgressCircle} from '../../ProgressCircle';
import {LabelContentHorizontal} from '../../LabelContentHorizontal';
import {CardBorder} from '../../CardBorder';

// styles
import {
  CardColumn,
  Separator,
  StyledLinkPrimary,
  DesktopWrapper,
  DesktopContent,
  DesktopCircleWrapper,
} from '../CardDetails-styles';
import {Subtitle} from '../../../styles';

// types
import {CardDetailsSubscriptionProps} from './CardDetailsSubscription';

// Number of items in the first column
const FIRST_COLUMN_ITEMS_DETAILED = 6;
const FIRST_COLUMN_ITEMS_SUMMARY = 4;

const CardDetailsSubscriptionDesktop = ({
  subscription,
  variant,
}: CardDetailsSubscriptionProps) => {
  const {t} = useTranslation();

  /**
   * Render the fields based on the variant
   */
  const renderFields = () => {
    const fields =
      variant === 'detailed'
        ? getDetailedFields(subscription, t)
        : getSummaryFields(subscription, t);
    const firstColumnItems =
      variant === 'detailed'
        ? FIRST_COLUMN_ITEMS_DETAILED
        : FIRST_COLUMN_ITEMS_SUMMARY;
    const [firstColumnFields, secondColumnFields] = [
      fields.slice(0, firstColumnItems),
      fields.slice(firstColumnItems),
    ];

    return (
      <>
        <CardColumn>
          {firstColumnFields.map(({label, content}) => (
            <LabelContentHorizontal
              key={label}
              label={label}
              content={content}
              isFullWidth
            />
          ))}
        </CardColumn>
        <Separator />
        <CardColumn>
          {secondColumnFields.map(({label, content}) => (
            <LabelContentHorizontal
              key={label}
              label={label}
              content={content}
              isFullWidth
            />
          ))}
          {variant === 'summary' && (
            <StyledLinkPrimary href={`/subscriptions/${subscription.id}`}>
              {t('dashboard_seeMore')}
            </StyledLinkPrimary>
          )}
        </CardColumn>
      </>
    );
  };

  return (
    <CardBorder variant="white" hasShadow>
      <DesktopWrapper>
        {variant === 'summary' && (
          <Subtitle bold="bold">
            {`${t('global_subscription')} ${subscription.subscriptionName}`}
          </Subtitle>
        )}
        <DesktopContent>
          {renderFields()}
          <Separator />
          <DesktopCircleWrapper>
            <ProgressCircle percentage={subscription.percentagePaid} />
          </DesktopCircleWrapper>
        </DesktopContent>
      </DesktopWrapper>
    </CardBorder>
  );
};

export default CardDetailsSubscriptionDesktop;
